import api from "./api";

export const announcementService = {
  // Get all announcements with pagination
  getAllAnnouncements: async (page = 1, limit = 10) => {
    const response = await api.get(`/announcement/getallannouncement`, {
      params: { page, limit },
    });
    return response.data;
  },

  // Get announcement by ID
  getAnnouncementById: async (id) => {
    const response = await api.get(`/announcement/getannouncement/${id}`);
    return response.data;
  },

  // Add new announcement
  addAnnouncement: async (formData) => {
    const response = await api.post(`/announcement/addannouncement`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  // Update announcement
  updateAnnouncement: async (id, formData) => {
    const response = await api.put(`/announcement/updateannouncement/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  // Delete announcement
  deleteAnnouncement: async (id) => {
    const response = await api.delete(`/announcement/deleteannouncement/${id}`);
    return response.data;
  },

  // Search announcements
  searchAnnouncement: async (searchQuery) => {
    const response = await api.get(`/announcement/searchannouncement`, {
      params: { search: searchQuery },
    });
    return response.data;
  },

  // Filter announcements by date
  filterAnnouncement: async (filterByDate) => {
    const response = await api.get(`/announcement/announcementfilter`, {
      params: { filterByDate },
    });
    return response.data;
  },
};

